import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import InputMask from 'react-input-mask';

import { useBasket } from '../../../../hooks/useBasket';
import { validEmail } from '../../../../shared/regex';
import CheckoutField from '../../../../ui/form-elements/CheckoutField/CheckoutField';

const CheckoutFields: FC = () => {
  const { checkout } = useBasket();
  const {
    register,
    formState: { errors },
    getValues,
    control,
  } = useFormContext();

  return (
    <>
      <Controller
        control={control}
        name="checkout_phone"
        rules={{
          required: 'Некорректный формат телефона',
          pattern: {
            value: /^(\+7|8)\s\d{3}\s\d{3}\s\d{2}\s\d{2}$/,
            message: 'Некорректный формат телефона',
          },
        }}
        render={({ field: { onChange, value } }) => {
          return (
            <InputMask
              mask="+7 999 999 99 99"
              maskChar={null}
              maskPlaceholder={null}
              value={value}
              onChange={onChange}
              inputMode="tel"
              width={100}
              defaultValue={checkout.checkout_phone}
            >
              <CheckoutField
                required
                label="Номер телефона"
                // @ts-ignore
                error={errors?.checkout_phone}
              />
            </InputMask>
          );
        }}
      />

      <CheckoutField
        {...register('checkout_email', {
          required: 'Почта обязательна',
          pattern: {
            value: validEmail,
            message: 'Некорректный формат почты',
          },
        })}
        required
        label="Email"
        // @ts-ignore
        error={errors.checkout_email}
      />
    </>
  );
};

export default CheckoutFields;
